import api from './api';

export const getSeedPhotos = async () => {
  const response = await api.get('/admin/seed-photos');
  return response.data;
};

export const uploadSeedPhoto = async (title, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  const response = await api.post(`/admin/seed-photos/${encodeURIComponent(title)}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};
